import { TWorkspaceUserDTO } from '@project/view-models';

export function generateWorkspaceUserIds(users: TWorkspaceUserDTO[]): string[] {
  const userIds = users.map((_user) => _user.userId);

  return userIds;
}
